import {Injectable} from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {ReminderModel} from "app/dar/common/services/reminder/reminder.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {IndividuService, Individu} from "@Common/core/services";
import {switchMap} from "rxjs/operators";
import {Pagination} from "@Common/widgets/general/pagination";
import {BehaviorSubject} from "rxjs";
import {SubSink} from "@Common/core/utils/subsink";

@Injectable({
  providedIn: 'root'
})
export class ReminderService extends DaoGeneric<ReminderModel> {
  private url = `${environment.baseUrl}/dar/reminder/`;
  extraParams: Map<string, string> = new Map<string, string>();
  subSink = new SubSink();

  constructor(
    private httpClient: HttpClient,
    private individuService: IndividuService,
    private reminderSvc: ReminderService,
  ) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  reminders = new BehaviorSubject<ReminderModel[]>([]);
  reminders$ = this.reminders.asObservable();

  refreshReminders() {
    this.individuService.individu$.pipe(
      switchMap((_ind: Individu) => {
        const extraParams: Map<string, string> = new Map<string, string>();
        extraParams.set("individu", _ind.uid);
        return this.listAllItems(extraParams)
      })
    ).subscribe((_reminders: Pagination) => {
      this.reminders.next(_reminders.list);
    });
  }

  delReminder(dossierId: number) {
    this.reminders.subscribe(
      (reminders: ReminderModel[]) => {
        const reminder = reminders.find(item => item.dossier === dossierId);
        if (reminder) {
          this.subSink.sink = this.delete(reminder).subscribe(() => this.refreshReminders());
        }
      }
    )
  }
}
